var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.4C1.27614 10.4 1.5 10.6239 1.5 10.9V13.4C1.5 13.9523 1.94772 14.4 2.5 14.4H14.5C15.0523 14.4 15.5 13.9523 15.5 13.4V10.9C15.5 10.6239 15.7239 10.4 16 10.4C16.2761 10.4 16.5 10.6239 16.5 10.9V13.4C16.5 14.5046 15.6046 15.4 14.5 15.4H2.5C1.39543 15.4 0.5 14.5046 0.5 13.4V10.9C0.5 10.6239 0.723858 10.4 1 10.4Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14645 12.3536C8.34171 12.5488 8.65829 12.5488 8.85355 12.3536L11.8536 9.35355C12.0488 9.15829 12.0488 8.84171 11.8536 8.64645C11.6583 8.45118 11.3417 8.45118 11.1464 8.64645L9 10.7929V2C9 1.72386 8.77614 1.5 8.5 1.5C8.22386 1.5 8 1.72386 8 2V10.7929L5.85355 8.64645C5.65829 8.45118 5.34171 8.45118 5.14645 8.64645C4.95118 8.84171 4.95118 9.15829 5.14645 9.35355L8.14645 12.3536Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8df0955f614f24b1738631f7652a14ea.svg";
export { ForwardRef as ReactComponent };